import { ReactNode, useContext, useEffect } from "react";
import { ShellContext } from "../context";

/** Indicates to the shell to block loading. */
export const BlockLoading = (): ReactNode => {
  const { incrementLoadingCount, decrementLoadingCount } = useContext(ShellContext);

  useEffect(() => {
    incrementLoadingCount();

    return (): void => {
      decrementLoadingCount();
    };
  }, [incrementLoadingCount, decrementLoadingCount]);

  return null;
};
